import {Injectable}                      from '@angular/core';
import {
  ApDynGridStatusColumnConfig
}                                        from '../../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  ApDynGridPropertyColumnConfig,
  FilterType,
  PropertyTemplate
}                                        from '../../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridGroupColumnConfig
}                                        from '../../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  ApDynGridEditColumnConfig
}                                        from '../../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                        from '../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {LanguageStore}                   from '../../../stores/translation/language.store';
import {
  ApTranslationService
}                                        from '../../../ap-utils/service/ap-translation.service';
import {GetRoundNumericPipe}             from '../../../ap-utils';
import {
  DropDownButtonData
}                                        from '../../../ap-dyngrids/config/ap-dyn-grid-button-column-config';
import {
  GetRoundNumericPipeConfig
}                                        from '../../../ap-utils/pipes/configs/get-round-numeric.pipe.config';
import {
  INFertilizationPlanningGridItem
}                                        from '../../types/ap-n-fertilization-planning-types';
import {
  OperationModesEnum
}                                        from '../../../stores/common/operation-modes.store';
import {
  NFertilizationService
}                                        from '../../../services/data/n-fertilization.service';
import {nameOf}                          from '../../../ap-core/utils/ap-name-of';
import {INFertilizationPlanBaseGridItem} from '../../types/n-fertilization-common.types';
import {
  IGridStatus
}                                        from '../../../ap-interface/interfaces/ap-grid-status.interface';

@Injectable({
  providedIn: 'root'
})
export class NFertilizationPlansGridBuilderService {
  constructor(private languageStore: LanguageStore,
              private translationService: ApTranslationService,
              private nFertilizationService: NFertilizationService,
              private roundNumericPipe: GetRoundNumericPipe) {
  }

  public planningBookingGrid(options: DropDownButtonData[]): ApDynGridColumnConfigBase[] {
    return [
      new ApDynGridStatusColumnConfig({
        field: `${nameOf<INFertilizationPlanBaseGridItem>('Status')}.${nameOf<IGridStatus>('state')}`,
        class: `${nameOf<INFertilizationPlanBaseGridItem>('Status')}.${nameOf<IGridStatus>('class')}`,
        description: `${nameOf<INFertilizationPlanBaseGridItem>('Status')}.${nameOf<IGridStatus>('description')}`,
        title: 'Global__Status',
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: nameOf<INFertilizationPlanBaseGridItem>('ApplicationDate'),
        title: 'Nutrients__FertilizationDate',
        tooltip: (dataItem: INFertilizationPlanBaseGridItem) => dataItem.ApplicationDateTooltip,
        dynCssClass: (dataItem: INFertilizationPlanBaseGridItem) => dataItem.ApplicationDateItalic ? ' italic' : '',
        sortIndex: 1,
        sortDesc: true,
        hide: true,
        width: 80,
        filterable: true,
        headerFilterable: true,
        format: this.languageStore.SelectedLanguage.DateFormat,
        template: PropertyTemplate.DATE
      }),
      new ApDynGridPropertyColumnConfig({
        field: nameOf<INFertilizationPlanBaseGridItem>('Product'),
        title: 'Global__Product',
        width: 100,
        filterable: true,
        headerFilterable: true,
        tooltip: (dataItem: INFertilizationPlanBaseGridItem) => dataItem.ProductTooltip
      }),
      new ApDynGridPropertyColumnConfig({
        field: nameOf<INFertilizationPlanBaseGridItem>('Crop'),
        title: 'Global__Crop',
        width: 100,
        filterable: true,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: nameOf<INFertilizationPlanBaseGridItem>('Appl'),
        title: 'Global__N_ApplNum',
        width: 60,
        filterable: true,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'Count',
        title: 'Base__Fields',
        hide: true,
        width: 60,
        tooltip: (dataItem: INFertilizationPlanBaseGridItem) => dataItem.FieldsTooltip,
        cssClass: 'right',
        filterType: FilterType.NUMBER,
        filterable: true,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: nameOf<INFertilizationPlanBaseGridItem>('Area'),
        title: 'Docu_Ini__Area',
        hide: true,
        width: 60,
        cssClass: 'right',
        filterType: FilterType.NUMBER,
        filterable: true,
        headerFilterable: true,
        template: PropertyTemplate.NUMBER
      }),
      new ApDynGridGroupColumnConfig({
        title: `${this.translationService.translate('Global__Sum')} ${this.translationService.translate('Product')}`,
        headerStyle: {'text-align': 'center'},
        hide: new ApDynGridColumnHideConfig({
          mapHide: true
        }),
        groupColumns: [
          new ApDynGridPropertyColumnConfig({
            field: nameOf<INFertilizationPlanBaseGridItem>('ApplSum'),
            tooltip: (dataItem: INFertilizationPlanBaseGridItem) => `${dataItem.ApplSum ?? 0} ${dataItem.ProductUnit}`,
            hide: new ApDynGridColumnHideConfig({
              mapHide: true
            }),
            width: 60,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [0, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            field: nameOf<INFertilizationPlanBaseGridItem>('ProductUnit'),
            hide: new ApDynGridColumnHideConfig({
              mapHide: true
            }),
            width: 40,
            filterable: true,
            headerFilterable: true
          })]
      }),
      new ApDynGridPropertyColumnConfig({
        field: nameOf<INFertilizationPlanBaseGridItem>('OperationMode'),
        title: 'Global__OperationMode',
        width: 100,
        filterable: true,
        headerFilterable: true
      }),
      new ApDynGridGroupColumnConfig({
        title: 'Nutrients__kg_N_per_ha',
        hide: true,
        groupColumns: [
          new ApDynGridPropertyColumnConfig({
            field: nameOf<INFertilizationPlanBaseGridItem>('Avg'),
            title: 'Global__Avg_Symbol',
            width: 60,
            cssClass: 'right',
            tooltip: (dataItem: INFertilizationPlanBaseGridItem) => this.generateTooltipForAverageColumn(dataItem),
            filterType: FilterType.NUMBER,
            filterable: true,
            headerFilterable: true,
            template: PropertyTemplate.NUMBER,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [0]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            field: nameOf<INFertilizationPlanningGridItem>('Min'),
            title: 'Global__Min',
            width: 60,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            filterable: true,
            headerFilterable: true,
            template: PropertyTemplate.NUMBER,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [0]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            field: nameOf<INFertilizationPlanBaseGridItem>('Max'),
            title: 'Global__Max',
            width: 60,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            filterable: true,
            headerFilterable: true,
            template: PropertyTemplate.NUMBER,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [0]
            }]
          })
        ]
      }),
      new ApDynGridPropertyColumnConfig({
        field: nameOf<INFertilizationPlanBaseGridItem>('Note'),
        title: 'Global__Note',
        filterable: true,
        headerFilterable: true,
        width: 100
      }),
      new ApDynGridEditColumnConfig({
        data: options
      })
    ];
  }

  private generateTooltipForAverageColumn(dataItem: INFertilizationPlanBaseGridItem): string | undefined {
    if (dataItem.OperationModeKey === OperationModesEnum.NFertilization) {
      return this.translationService.translate('Fertilisation__ReferenceValue_kg_N_per_ha');
    }
    const isRape = this.nFertilizationService.isRapeCrop([dataItem.CropId]);
    if ((dataItem.OperationModeKey === OperationModesEnum.Constant || dataItem.OperationModeKey === OperationModesEnum.TargetValue)
      || ((dataItem.OperationModeKey === OperationModesEnum.ApplicationMapAbsolute || dataItem.OperationModeKey === OperationModesEnum.ApplicationMap) && !isRape)) {
      return this.translationService.translate('Fertilisation__TargetRate_Nutrient_kg_N_per_ha');
    }
    if (dataItem.OperationModeKey === OperationModesEnum.RapeFertilization
      || ((dataItem.OperationModeKey === OperationModesEnum.ApplicationMapAbsolute || dataItem.OperationModeKey === OperationModesEnum.ApplicationMap) && isRape)) {
      return this.translationService.translate('N__SetPoint_kg_N_per_ha');
    }
    return undefined;
  }
}
